import React, { useState } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import AccountUtil from '../../../account/components/utils/AccountUtil';
import { getSystemOfUnits } from '../../../util/user';

const unitOptions = {
  Metric: 'Units: Metric',
  Imperial: 'Units: Imperial',
};

const isCorrLogixAnalysisPage = () => { 
	const pathname = (window?.location?.pathname || '').toLowerCase().split('?')[0];
	const parts = (pathname || '').toLowerCase().split('/').filter(v => v);
	return parts[0] === 'corrlogix' && parts[1] === 'map';
}

const updateSystemOfUnits = (val, onComplete) => {
		const arr = [
			{ Name: 'custom:system_of_units', Value: val },
		];
		return AccountUtil.updateattributes({ userAttributes: arr }, onComplete);
}

const refreshSession = async () => {
	await AccountUtil.refresh()
};


const SystemOfUnitsDropdown = () => {
  const [unit, setUnit] = useState(getSystemOfUnits());
  const [isSaving, setIsSaving] = useState(false);

	const handleSelect = (selectedKey) => {
		setUnit(selectedKey);
		setIsSaving(true)
		updateSystemOfUnits(selectedKey, async () => {
			await refreshSession();
			window.location.reload();
		});
	};
	
	if (!isCorrLogixAnalysisPage()) {
		return null;
	}

	return (
		<div style={{ display: 'inline-block', position: 'static', overflow: 'visible', marginRight: '5px' }}>
			<div style={{ position: 'relative', transform: 'translateY(-2px)', zIndex: '99999'}}>
				<DropdownButton
					id="unit-dropdown"
					title={unitOptions[unit]}
					onSelect={handleSelect}
					rootCloseEvent="mousedown"
					disabled={isSaving}
				>
					<MenuItem eventKey="Metric">Metric (meters)</MenuItem>
					<MenuItem eventKey="Imperial">Imperial (feet)</MenuItem>
				</DropdownButton>
				{isSaving && (
					<div style={{ position: 'absolute', top: '7px', right: '10px', zIndex: '2', color: '#333' }}>
						<i className='fa fa-gear fa-spin' />
					</div>
				)}
			</div>
		</div>
  );
}

export default SystemOfUnitsDropdown;